
define('text!common/views/ui/video-ads-skip-overlay.html',[],function () { return '<div class="js-ads-skip vjs-ads-skip">\n    <span class="vjs-ads-skip__countdown">You may skip this advert in <span class="js-skip-remaining-time"><%=skipTimeout%></span> seconds</span>\n</div>\n';});

